<template>
    <div>
        <app-header title="Filter wählen" :close="'true'" :path="'meine_trends'" :backTop="'true'"></app-header>
        <div class="page">
            <h1>Wähle die Trends die dich wirklich interessieren.</h1>
            <h4>Filtere deine Einnahmen nach einzelnen Songs, Länder etc.</h4>
            <table>
                <tr>
                    <td><i @click="first=!first" class="fa" :class="{ 'fa-circle-o': !first, 'fa-check-circle': first}"></i></td>
                    <td><span>Typen</span></td>
                </tr>
                <tr>
                    <td><i @click="second=!second" class="fa" :class="{ 'fa-circle-o': !second, 'fa-check-circle': second}"></i></td>
                    <td><span>Songs</span></td>
                </tr>
                <tr>
                    <td><i @click="third=!third" class="fa" :class="{ 'fa-circle-o': !third, 'fa-check-circle': third}"></i></td>
                    <td><span>Release</span></td>
                </tr>
                <tr>
                    <td><i @click="fourth=!fourth" class="fa" :class="{ 'fa-circle-o': !fourth, 'fa-check-circle': fourth}"></i></td>
                    <td><span>Land</span></td>
                </tr>
                <tr>
                    <td><i @click="fifth=!fifth" class="fa" :class="{ 'fa-circle-o': !fifth, 'fa-check-circle': fifth}"></i></td>
                    <td><span>Stores</span></td>
                </tr>
            </table>
            <form>
                <router-link :to="{name: 'meine_trends'}" tag="button">Filter wählen</router-link>
            </form>

        </div>
    </div>
</template>

<script>
    import Header from '../Header';

    export default {
        data() {
            return {
                first: false,
                second: false,
                third: true,
                fourth: false,
                fifth: false

            }
        },
        computed: {
            items() {
                return this.$store.getters.Meine_trends;
            }
        },
        components: {
            appHeader: Header
        },
        methods: {
            check() {
                console.log(this.classList);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/css/variables';

    .page {
        padding-top: 60px;
        overflow: hidden;
        color: $font-color_dark;

        h1 {
            font-size: 2.6rem;
            font-weight: 700;
            letter-spacing: -0, 35px;
            margin-left: 20px;
            margin-top: 35px;
            margin-bottom: 10px;
        }

        h4 {
            font-family: "SF UI Text Light";
            font-size: 1.45rem;
            letter-spacing: -0, 2px;
            font-weight: 300;
            margin-left: 20px;
            line-height: 22px;

        }

        table {
            margin-top: 8px;
            margin-left: 18px;

            td {
                padding: 14px 2px;
                vertical-align: middle;
                i {
                    font-size: 2.8rem;

                    &.fa-check-circle {
                        color: $check-circle_color;
                    }

                    &.fa-circle-o {
                        color: $o-circle_color;
                    }
                }
                span {
                    padding-left: 4px;
                    font-size: 1.5rem;
                    font-family: "SF UI Text Light";
                    font-weight: 300;
                }
            }
        }
        form{
            margin-top:35px;
            text-align: center;
            button{
                font-size:1.5rem;
                margin:10px;
                padding: 10px 25px;
                margin:2px;
                border-radius: 5px;
                border: none;
                font-weight: 700;
                width:43%;
                &:first-of-type{
                    background-color: $button_full-backGroundColor;
                    color: $button-full_color;

                }
            }
        }

    }


</style>



// WEBPACK FOOTER //
// src/components/filter_wahlen/Filter_wahlen.vue